import { cva } from 'class-variance-authority';

export const cvaFreeParking = cva([
  'FreeParkingStyles-cvaFreeParking',
  'w-full z-30 overflow-hidden',
  'bg-cDarkGray rounded-t-[0.8rem]',
  'transition-all duration-300',
]);

export const cvaFreeParkingInner = cva(
  [
    'FreeParkingStyles-cvaFreeParkingInner',
    'relative',
    //   'px-2.4 py-2',
    'flex flex-col gap-2',
    'h-max',
  ],
  {
    variants: {
      isScroll: {
        true: [
          // 'before:absolute before:bottom-[-2rem] before:left-0',
          // 'before:w-full before:h-2.4',
          // 'before:bg-gradient-to-b from-[#070417] to-transparent before:absolute before:opacity-[0.3]',
        ],
      },
    },
  }
);

export const cvaFreeParkingBox = cva([
  'FreeParkingStyles-cvaFreeParkingTitleBox',
  'flex flex-col gap-1.2 justify-between',
  'mx-2.4 pb-2 w-[calc(100%-4.8rem)]',
  'border-b !border-b-[3px] border-[#373541]',
]);

export const cvaFreeParkingCols = cva([
  'FreeParkingStyles-cvaFreeParkingTitleCols',
  'grid grid-cols-2 gap-1.2',
]);

export const cvaFreeParkingTitle = cva([
  'FreeParkingStyles-cvaFreeParkingTitle',
  'text-m-sb text-left text-cGray',
  'mt-0.8',
]);
export const cvaFreeParkingText = cva(
  [
    'FreeParkingStyles-cvaFreeParkingText',
    'text-m-sb text-left',
    '[&>span]:text-cGreen',
    '[&>span>span]:text-[#EC5A5A]',
    'flex items-center gap-0.8',
  ],
  {
    variants: {
      listText: {
        true: 'pl-2.4 pb-1.2',
      },
    },
  }
);

export const cvaFreeParkingBadges = cva([
  'FreeParkingStyles-cvaFreeParkingBadge',
  'flex flex-wrap gap-0.4',
]);

export const cvaFreeParkingBadge = cva([
  'FreeParkingStyles-cvaFreeParkingBadge',
  'text-m-sb text-cWhite',
  'py-0.7 px-1.2',
  'bg-[#373541] rounded-[8px]',
  'h-3.4 w-fit',
]);

export const cvaFreeParkingIcon = cva([
  'FreeParkingStyles-cvaFreeParkingIcon',
  'w-2.4 min-w-2.4 h-2.4',
]);
